export const DEFAULT_FORMAT = "hex";
